import { Link } from "react-router-dom";

interface UnderNavbarProps {
  colorTitle: string;
  title: string;
  text: string;
}

const UnderNavbar = ({ colorTitle, title, text }: UnderNavbarProps) => {
  return (
    <div className="bg-gradient-to-r from-[#ECEDF2] to-[#D1D3DE] flex flex-col justify-center items-center text-center">
      <div className="text-[44px] font-bold pt-12 pb-8">
        <span className="text-orange-500">{colorTitle}</span>
        {title}
      </div>
      <div className="text-grey-800">{text}</div>
      <div className="pt-12 flex pb-16">
        <Link
          className="bg-white text-black border border-gray-300 px-4 py-2 rounded-md mr-4"
          to="/about"
        >
          Learn more
        </Link>

        <Link
          className="bg-[#1672EC] text-white px-4 py-2 rounded-md"
          to="/register"
        >
          Get started for free
        </Link>
      </div>
    </div>
  );
};

export default UnderNavbar;
